// Для возможности конфигурации без пересборки проекта в index.html подключен скрипт /js/runtime-config.js,
// который выполняется перед скриптом приложения, и в котором можно определить объект window.runtimeConfig.

const configOverrides = window.runtimeConfig || {};

const blitzUrl = process.env.VUE_APP_BLITZ_URL;

const config = {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  apiAuthUrl: process.env.VUE_APP_OIDC_AUTHORITY,
  publicBaseUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
  authUseMock: process.env.VUE_APP_AUTH_USE_MOCK === 'true',
  contourType: process.env.VUE_APP_CONTOUR_TYPE || 'opened',
  oidc: {
    authorizationEndpoint: blitzUrl + '/oauth/ae',
    logoutUrl: blitzUrl + '/oauth/logout',
    clientId: process.env.VUE_APP_OIDC_CLIENT_ID,
    redirectUri: process.env.VUE_APP_OIDC_REDIRECT_URI,
    postLogoutRedirectUri: process.env.VUE_APP_OIDC_REDIRECT_URI,
    scope: process.env.VUE_APP_OIDC_SCOPE || 'openid profile',
  },
};

export default {
  ...config,
  ...configOverrides,
  oidc: { ...config.oidc, ...configOverrides.oidc },
};
